/* eslint-disable import/prefer-default-export */
/* eslint-disable no-console */
export default function getSportsSubtitle(title) {
  const parts = title.split(':')

  if (parts.length > 1) {
    return parts.slice(1).join(':')
  }

  return ''
}

export const isValidString = str => typeof str === 'string' && str.length > 0

export const isDeepLink = (href) => {
  if (!isValidString(href)) {
    console.warn('warning, invalid string passed to isDeepLink', href)
    return false
  }
  return href.includes('source') || href.includes('cid')
}
